import { useQuery } from 'react-query'

import { impactPeriodService } from 'src/services/impact-period.service'
import { QUERY_KEYS } from 'src/constants'

export const useImpactPeriodChanges = (id: string) => {
  return useQuery([QUERY_KEYS.IMPACT_PERIOD_CHANGES, id], () =>
    impactPeriodService.getImpactPeriodChanges(id),
  )
}
